import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

export const useDayCardStyles = makeStyles((theme: Theme) =>
  createStyles({
    dayContainer: {
      minHeight: '500px',
      padding: theme.spacing(1),
      backgroundColor: '#fff',
    },
    closedDay: {
      backgroundColor: '#ffebee',
    },
    serviceItem: {
      marginBottom: theme.spacing(1),
      padding: theme.spacing(1),
      border: '1px solid #e0e0e0',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: '#f9f9f9',
    },
    activeService: {
      backgroundColor: '#e8f5e8',
      borderColor: '#4caf50',
    },
    closedService: {
      backgroundColor: '#ffebee',
      borderColor: '#f44336',
    },
    serviceName: {
      fontWeight: 600,
      fontSize: '0.875rem',
      marginBottom: theme.spacing(0.5),
    },
    serviceTime: {
      fontSize: '0.75rem',
      color: '#666',
    },
    closeLabel: {
      backgroundColor: '#f44336',
      color: 'white',
      fontWeight: 600,
      marginBottom: theme.spacing(0.5),
    },
    supplyIntakeContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    checkIcon: {
      color: '#4caf50',
      fontSize: '1rem',
    },
  }),
);
